import likertExampleImg from "../assets/intro/likert-example.png";
import scenarioExampleImg from "../assets/intro/scenario-example.png";

interface QuestionsIntroProps {
  onStart: () => void;
}

export function QuestionsIntro({ onStart }: QuestionsIntroProps) {
  return (
    <section className="bloom-questions-intro" aria-label="Uitleg voor de vragen">
      <div className="bloom-questions-intro__card">
        <h2 className="bloom-questions-intro__title">Welkom bij Bloom</h2>

        <div className="bloom-questions-intro__body">
          <p>
            Waarschijnlijk start je binnenkort met een ACT-behandeling, of ben je daar al mee
            bezig. Binnen Acceptance and Commitment Therapie (ACT) wordt gewerkt met verschillende
            onderdelen.
          </p>
          <p>
            Deze onderdelen gaan over gevoelens, gedachten, aandacht, hoe je naar jezelf kijkt,
            wat belangrijk is voor jou en welke stappen je zet. Soms kun je het ene stukje van ACT
            al heel erg goed en heeft een ander stuk meer aandacht nodig.
          </p>
          <p>
            Je krijgt straks een aantal korte vragen. Deze vragen helpen om te ontdekken welke
            onderdelen bij jou al goed ontwikkeld zijn en welke onderdelen in de behandeling extra
            aandacht kunnen krijgen. Samen leiden deze onderdelen tot meer psychologische
            flexibiliteit. Als je meer psychologische flexibiliteit hebt, dan kun je vaak beter met
            tegenslag omgaan, denk je positiever over jezelf en heb je minder last van vervelende
            gevoelens. Ook doe je dan vaker dingen die voor jou belangrijk zijn.
          </p>
        </div>

        <figure className="bloom-questions-intro__example">
          <figcaption className="bloom-questions-intro__example-label">
            Je krijgt eerst een aantal vragen zoals:
          </figcaption>
          <img
            className="bloom-questions-intro__example-img"
            src={likertExampleImg}
            alt="Voorbeeld stelling met antwoordopties van Nooit tot Altijd"
          />
        </figure>

        <div className="bloom-questions-intro__body">
          <p>
            Kies het antwoord dat het beste bij jou past. Als jij bijna altijd spanning voelt bij
            iets nieuws, kies je Altijd. Als je dat nooit hebt, kies je Nooit. Let op: ook als je
            iets bijna nooit het geval is bij jou, dan kies je voor Nooit. En als het wisselt,
            kies je Soms, Regelmatig of Vaak.
          </p>
        </div>

        <figure className="bloom-questions-intro__example">
          <figcaption className="bloom-questions-intro__example-label">
            Daarna krijg je een aantal situaties, waarin je kiest voor hoe jij waarschijnlijk zou
            reageren in die situatie. Bijvoorbeeld:
          </figcaption>
          <img
            className="bloom-questions-intro__example-img"
            src={scenarioExampleImg}
            alt="Voorbeeld situatie-vraag over boosheid met vijf antwoordopties"
          />
        </figure>

        <div className="bloom-questions-intro__body">
          <p>
            Er zijn geen goede of foute antwoorden. Het gaat erom wat op dit moment het beste bij
            jou past.
          </p>
          <p>
            Terwijl je de vragen beantwoordt, groeit er langzaam een tuin. Aan het eind zie je
            jouw persoonlijke Bloom-tuin. Die laat zien waar al veel kracht zit en welke delen bij
            jou nog verder kunnen groeien.
          </p>
        </div>

        <button
          type="button"
          className="bloom-btn bloom-btn--primary bloom-questions-intro__start"
          onClick={onStart}
        >
          Start
        </button>
      </div>
    </section>
  );
}
